import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useRef, useEffect } from "react";
import { apiClient } from "@groot/shell/lib/api";
import type { MomentRequest } from "@/pages/moment-request/hooks/useMomentRequests";

export function PublicMomentView() {
  const { viewLink } = useParams<{ viewLink: string }>();
  const videoRef = useRef<HTMLVideoElement>(null);

  const { data } = useQuery({
    queryKey: ["moment-requests", "view", viewLink],
    queryFn: async () => {
      return apiClient.get<MomentRequest & { latestVideo?: { id: number; fileName: string } }>(
        `/public/moment-requests/view/${viewLink}`,
      );
    },
    enabled: !!viewLink,
  });

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(() => {});
    }
  }, [data]);

  const videoId = data?.latestVideo?.id;

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center">
      {videoId ? (
        <video
          ref={videoRef}
          key={videoId}
          src={`/api/v1/public/moment-requests/view/${viewLink}/video`}
          autoPlay
          playsInline
          controls
          className="max-w-full max-h-full w-auto h-auto"
        />
      ) : (
        <div className="flex flex-col items-center gap-3">
          <div className="size-8 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          <p className="text-sm text-white/50">Loading video…</p>
        </div>
      )}
    </div>
  );
}
